"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Utils {
    static isTabVisible() {
        return document.visibilityState === "visible";
    }
}
exports.Utils = Utils;
Utils.generateGuid = () => {
    const r = new Array(8);
    for (let i = 0; i < r.length; i += 2) {
        const val = Math.floor(Math.random() * 0x100000000);
        // tslint:disable-next-line: no-bitwise
        r[i] = Utils.formatAsHex(val & 0xffff);
        // tslint:disable-next-line: no-bitwise
        r[i + 1] = Utils.formatAsHex(val >>> 16);
        if (i + 1 === 3) {
            // RFC4122 requires a 4 in this position
            r[i + 1] = "4" + r[i + 1].substring(1);
        }
        if (i === 4) {
            // RFC4122 requires [089ab] hex values in the first position
            // tslint:disable-next-line:no-bitwise
            r[i] = (val & 0x3 | 0x8).toString(16) + r[i].substring(1);
        }
    }
    return (r[0] +
        r[1] +
        "-" +
        r[2] +
        "-" +
        r[3] +
        "-" +
        r[4] +
        "-" +
        r[5] +
        r[6] +
        r[7]);
};
Utils.generateHash = (input) => {
    let hash = 0;
    if (input.length === 0) {
        return hash;
    }
    for (let i = 0; i < input.length; i += 1) {
        const char = input.charCodeAt(i);
        // tslint:disable-next-line: no-bitwise
        hash = (hash << 5) - hash + char;
        // tslint:disable-next-line: no-bitwise
        hash = hash & hash;
    }
    return hash;
};
Utils.formatAsHex = (n) => {
    let hex = n.toString(16);
    const padding = 4 - hex.length;
    for (let i = 0; i < padding; i += 1) {
        hex = "0" + hex;
    }
    return hex;
};
